import React, { useMemo } from 'react'
import {
  setIsSidebarVisible
} from 'store/redux/layout'
import { useDispatch, useSelector } from 'react-redux'
import LayoutGroupBoard from './LayoutGroupBoard'
import { createSelector } from 'reselect'
import LayoutGroupItem from './LayoutGroupItem'
import LayoutGroupItemIcon from './LayoutGroupItemIcon'
import KanBoIcon from 'components/KanBoIcon'
import styled from 'styled-components'

const LinkIcon = styled(LayoutGroupItemIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  color: #2196f3;
`

type Props = {
  layoutId: number
  id: number
}

const LayoutGroup: React.FC<Props> = ({
  layoutId,
  id,
}) => {
  const dispatch = useDispatch()

  const elements = useSelector<any, any>(useMemo(() => createSelector(
    state => state['view-home'].layoutGroupsByKey[`${layoutId}-${id}`].elements,
    elements => elements.filter(element => !element.isBusy)
  ), [layoutId, id]))

  return elements.map(element => {
    switch (element.type) {
      case 'board':
        return (
          <LayoutGroupBoard
            boardId={element.boardId}
          />
        )
      case 'link':
        return (
          <a
            href={element.url}
            target='_blank'
            rel='noopener noreferrer'
            className='clear-link-style'
          >
            <LayoutGroupItem
              icon={
                <LinkIcon>
                  <KanBoIcon name='kanbo-16-link' />
                </LinkIcon>
              }
              title={element.name}
              onClick={() => {
                dispatch(setIsSidebarVisible(false))
              }}
            />
          </a>
        )
      default:
        return null
    }
  })
}

export default LayoutGroup

